import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "@/common/hooks";
import SideModal from "@/common/components/CustomModal/SideModal";
import ModalTitleHeader from "@/common/components/ModalTitleHeader";
import CustomInput from "@/common/components/CustomInput";
import CustomButton from "@/common/components/CustomButton";
import ModalNavLinks from "../../../../components/ModalNavLinkFunding";
// import { walletActions } from "../../../../store/slice";
import { FormatNumber, getCurrentWalletType } from "@/common/utils/helpers";
import { iHandleChange } from "../../../../types";
import {
  addCommas,
  removeCommas,
  removeNonNumeric,
} from "@/common/utils/helpers";
import routes from "@/common/routes";
import Language from "@/common/utils/language/en";
import ShareholdersWithKyc from "../../../../components/ShareholdersWithKyc";
import { useFundWalletMutation } from "@/module/wallet/service/api";

const { FundWalletForm: PageDictionary } =
  Language.protected.walletModals.funding;

const initialstate = {
  message: "",
  type: "funding_amount",
  shareholder_id: "",
};

function FundWalletForm() {
  const { appid } = useParams();
  const navigate = useNavigate();
  const location = useLocation().state?.background;
  const [inData, setInData] = useState(initialstate);
  const [fundWallet, { isLoading: loading }] = useFundWalletMutation();

  // const { isEstablishingConnection, isConnected } = useAppSelector(
  //   (state) => state.wallet.socket
  // );
  const is_bank = useAppSelector(
    (state) => state.app.tabApps.find((app) => app._id === appid)?.is_bank
  );

  const exchange_rate = useAppSelector(
    (state) => state.wallet.exchange_rate.data
  );

  const usdValue = exchange_rate?.fund_rate?.rate
    ? parseInt(
        removeCommas(inData.message) ? removeCommas(inData.message) : "0"
      ) / exchange_rate?.fund_rate?.rate
    : 0;

  const rate = FormatNumber(usdValue, true);

  const changeHandler: iHandleChange = useCallback((e) => {
    const { value } = e.target;
    setInData((prev) => ({
      ...prev,
      message: addCommas(removeNonNumeric(value)),
    }));
  }, []);
  const radioChangeHandler: iHandleChange = (e) => {
    const { value } = e.target;
    setInData((prev) => ({
      ...prev,
      shareholder_id: value,
    }));
  };

  const backDrop = () => {
    if (!appid || loading) return;
    let path =
      location?.pathname ??
      routes.protected.applications.app.wallet.link(appid);
    navigate(path, { replace: true });
  };

  useEffect(() => {
    if (!appid) return;
    if (!exchange_rate?.fund_rate.from) {
      backDrop();
    }
  }, []); // eslint-disable-line

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!appid) return;
    const amount = removeCommas(inData.message);

    fundWallet({
      appid,
      data: {
        amount,
        shareholder_id: inData.shareholder_id,
        wallet_type: getCurrentWalletType(location.pathname),
      },
    })
      .unwrap()
      .then(() => {
        const path =
          routes.protected.applications.app.wallet.fund.payment_processing.link(
            appid,
            1
          );
        navigate(path, {
          state: {
            background: location,
            amount: inData.message,
            currency: exchange_rate?.fund_rate?.to,
          },
        });
      });
  };

  return (
    <SideModal
      onclickBackDrop={backDrop}
      className="p-8 md:pt-22 md:pl-15 md:pr-28"
    >
      <ModalTitleHeader
        title={PageDictionary.header.title}
        subtitle={PageDictionary.header.subtitle}
      />
      <form className="flex flex-col gap-y-10 pt-11" onSubmit={submitHandler}>
        <ModalNavLinks is_bank={is_bank} />
        <div className="relative">
          <div className="relative">
            <span className="absolute bottom-4 left-4 z-[2] uppercase">
              {exchange_rate?.fund_rate?.to}
            </span>
            <CustomInput
              label={PageDictionary.form.amount_label}
              className="pl-[4.25rem]"
              value={inData.message}
              onChange={changeHandler}
            />
          </div>
          <div className="flex justify-between items-center text-sm mt-1">
            <p className="absolut right-5">
              Min Fund Amount:{" "}
              <span className="text-red-10">
                {exchange_rate?.fund_rate?.to}
                {addCommas(
                  (10 * (exchange_rate?.fund_rate?.rate ?? 0)).toString()
                )}
              </span>
            </p>
            <p className="absolut right-5">
              {PageDictionary.form.amount_dollar}{" "}
              <span className="text-red-10">{rate}</span>
            </p>
          </div>
        </div>

        <p className="text-sm text-gray-400">{PageDictionary.form.warn_text}</p>

        <ShareholdersWithKyc
          value={inData.shareholder_id}
          disabled={loading}
          radioChangeHandler={radioChangeHandler}
        />

        <CustomButton
          disabled={
            inData.message === "" ||
            inData.shareholder_id === "" ||
            usdValue < 10
          }
          // isloading={isEstablishingConnection}
          isloading={loading}
          className="mt-3 self-start rounded-lg py-3 px-10 text-sm leading-6"
        >
          {PageDictionary.form.submit_btn}
        </CustomButton>
      </form>
    </SideModal>
  );
}

export default FundWalletForm;
